import { APP_ROUTES_USER_VIDEO_GUIDE } from '@/src/constants'
import { DeleteModal } from '@ui'
import { useNavigate } from 'react-router-dom'

type Props = {
  onClose: () => void
}

export const AdminHelpGuideModal = ({ onClose }: Props) => {
  const navigate = useNavigate()

  return (
    <DeleteModal
      className=""
      description="Click to watch videos on how to navigate the access EMR System anytime"
      handleSubmit={() => {
        navigate(APP_ROUTES_USER_VIDEO_GUIDE)
        onClose()
      }}
      headerIcon={<div />}
      lBtnLabel="Skip for now"
      leftIcon={<div />}
      noIcon
      onClose={onClose}
      rBtnLabel="Watch tutorial"
      rightIcon={<div />}
      title="Want to see Tutorial?"
    />
  )
}
